import React from 'react'
import styled from '@emotion/styled'

type WithChildren<T = {}> =
    T & {
        children?: React.ReactNode
        onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    }

const Content = styled.button`
    border: 0;
    padding: 0.5rem;
    outline: none;
    cursor: pointer;
    background: inherit;
`

export function IconButton({ children, onClick }: WithChildren) {
    return <Content onClick={onClick}>
        {children}
    </Content>
}
